/**
 * メッセージカードの各入力項目の最大文字数、最大行数の設定
 */
const Q_BOOK_MAX_LENGTH = 295;
const Q_AUTHORNAME_MAX_LENGTH = 90;
const Q_MESSAGECARD_MAX_LENGTH = 200;

/**
 * オプション商品をカートに追加する
 * @return void
 */
function addOptionProduct() {
    // 選択したツールのvariantId
    let variant_id = document.getElementById('tool_variant_id').value;

    // フォームの要素
    let toolSelect = document.getElementById('toolSelect').value;
    let sceneSelect = document.getElementById('sceneSelect').value;
    let deliveryType = document.getElementById('delivery_type');
    let vendorAttribute = document.getElementById('vendor_attribute');
    let authorName = document.getElementById('author_name');
    let recipientName = document.getElementById('recipient_name');
    let omoiToolQ1 = document.getElementById('omoi_tool_q1');
    let omoiToolQ2 = document.getElementById('omoi_tool_q2');
    let omoiToolQ3 = document.getElementById('omoi_tool_q3');
    let omoiToolQ4 = document.getElementById('omoi_tool_q4');
    let vendorSelectElement = document.getElementById('vendor-select');
    let selectedOption = vendorSelectElement.options[vendorSelectElement.selectedIndex];

    // 入力チェック
    if (checkMessageInput(toolSelect, authorName, recipientName, omoiToolQ1, omoiToolQ2, omoiToolQ3, omoiToolQ4) === true) {
        return
    }

    // 誤操作防止のためinputタグ、aタグを非活性化
    document.querySelectorAll("a").forEach(e => {
        e.setAttribute('href', 'javascript:void(0)');
        e.classList.add('disabled');
    });
    document.querySelectorAll("input").forEach(e => e.disabled = true);

    let deliveryTypeValue = deliveryType.value;
    let vendorAttributeValue = vendorAttribute.value;
    let authorNameValue = toolSelect === 'book' ? authorName.value : '';
    let recipientNameValue = toolSelect === 'messageCard' ? recipientName.value : '';
    let omoiToolQ1Value = document.getElementById('omoi_tool_q1').value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ2Value = document.getElementById('omoi_tool_q2').value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ3Value = document.getElementById('omoi_tool_q3').value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ4Value = document.getElementById('omoi_tool_q4').value.replace(/(\r\n|\n|\r)/gm, "");
    let tsukurite = selectedOption.getAttribute('data-tsukurite');
    let toolSelectValue = '';

    if (toolSelect === 'book') {
        toolSelectValue = '本';
    } else if (toolSelect === 'messageCard') {
        toolSelectValue = 'メッセージカード';
    } else {
        toolSelectValue = 'ツール無し';
    }

    const checkoutButton = document.querySelector('button[name="checkout"]');
    checkoutButton.disabled = false;
    checkoutButton.classList.remove('disabled');
    
    // ツール無し選択時の購入ボタンクリックイベントを設定
    setupNoToolCheckout();

    // パラメータをセット
    let params = {
        'attributes':{
            'tool': toolSelectValue,
            'tool_variant_id': variant_id,
            'scene': sceneSelect,
            'omoi_tool_q3': omoiToolQ3Value,
            'omoi_tool_q4': omoiToolQ4Value,
            'vendor_attribute': vendorAttributeValue,
            'vendor_attribute_url': tsukurite,
        }
    }
    if (toolSelectValue === '本') {
        params['attributes']['delivery_type'] = deliveryTypeValue;
        params['attributes']['author_name'] = authorNameValue;
        params['attributes']['omoi_tool_q1'] = omoiToolQ1Value;
        params['attributes']['omoi_tool_q2'] = omoiToolQ2Value;
        params['attributes']['recipient_name'] = null;
    } else if (toolSelectValue === 'メッセージカード') {
        params['attributes']['delivery_type'] = null;
        params['attributes']['author_name'] = null;
        params['attributes']['omoi_tool_q1'] = null;
        params['attributes']['omoi_tool_q2'] = null;
        params['attributes']['recipient_name'] = recipientNameValue;
    } else {
        params['attributes']['delivery_type'] = null;
        params['attributes']['author_name'] = null;
        params['attributes']['omoi_tool_q1'] = null;
        params['attributes']['omoi_tool_q2'] = null;
        params['attributes']['recipient_name'] = null;
    }

    fetch("/cart/update.js", {
        method: "POST",
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(() => {
            // 数量をセット
            let quantity = 1;

            // パラメータをセット
            let product_params = {
                'id': variant_id,
                'quantity': quantity
            }

            // カートイン
            fetch("/cart/add.js", {
                method: "POST",
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(product_params)
            })
                .then(() => {
                    window.location.href = '/cart';
                })
        })
}

/**
 * メッセージカードの内容を変更する
 * @return void
 */
function editMessageCard () {
    let toolSelect = document.getElementById('toolSelect').value;
    let toolSelectValue = '';
    let sceneSelectValue = document.getElementById('sceneSelect').value;
    let vendorAttribute = document.getElementById('vendor_attribute');
    let deliveryType = document.getElementById('delivery_type');
    let authorName = document.getElementById('author_name');
    let recipientName = document.getElementById('recipient_name');
    let omoiToolQ1 = document.getElementById('omoi_tool_q1');
    let omoiToolQ2 = document.getElementById('omoi_tool_q2');
    let omoiToolQ3 = document.getElementById('omoi_tool_q3');
    let omoiToolQ4 = document.getElementById('omoi_tool_q4');
    let vendorSelectElement = document.getElementById('vendor-select');
    let selectedOption = vendorSelectElement.options[vendorSelectElement.selectedIndex];

    // 元々選択していたツールと異なるツールを選択している場合、現在カートに入っているツールを削除
    let tool_variant_id = document.getElementById('tool_variant_id').value;
    let current_selected_tool_variant_id = document.getElementById('current_selected_tool_variant_id').value;//元々選択していてattributeに入っている値

    let change_flag = false;
    if (tool_variant_id !== current_selected_tool_variant_id) {
        // カートに入っているツールを変更した場合、カート内の変更前の商品を削除し、変更後の商品で追加する
        change_flag = true;
    }

    // 入力エラーがある場合はカートに追加せず終了
    if (checkMessageInput(toolSelect, authorName, recipientName, omoiToolQ1, omoiToolQ2, omoiToolQ3, omoiToolQ4) === true) {
        return;
    }

    let vendorAttributeValue = vendorAttribute.value;
    let deliveryTypeValue = deliveryType.value;
    let authorNameValue = authorName.value;
    let recipientNameValue = recipientName.value;
    let omoiToolQ1Value = omoiToolQ1.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ2Value = omoiToolQ2.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ3Value = omoiToolQ3.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ4Value = omoiToolQ4.value.replace(/(\r\n|\n|\r)/gm, "");
    let tsukurite = selectedOption.getAttribute('data-tsukurite');

    if (toolSelect === 'book') {
        toolSelectValue = '本';
    } else if (toolSelect === 'messageCard') {
        toolSelectValue = 'メッセージカード';
    } else {
        toolSelectValue = 'ツール無し';
    }
    if (!vendorAttributeValue) {
        vendorAttributeValue  = '';
    }
    if (!deliveryTypeValue || toolSelect !== 'book') {
        deliveryTypeValue = '';
    }
    if (!authorNameValue || toolSelect !== 'book') {
        authorNameValue  = '';
    }
    if (!recipientNameValue || toolSelect !== 'messageCard') {
        recipientNameValue  = '';
    }
    if (!omoiToolQ1Value || toolSelect !== 'book') {
        omoiToolQ1Value  = '';
    }
    if (!omoiToolQ2Value || toolSelect !== 'book') {
        omoiToolQ2Value  = '';
    }
    if (!omoiToolQ3Value) {
        omoiToolQ3Value  = '';
    }
    if (!omoiToolQ4Value) {
        omoiToolQ4Value  = '';
    }
    if (!tsukurite) {
        tsukurite  = '';
    }
    if (!sceneSelectValue) {
        sceneSelectValue  = '';
    }

    // // Cart Attributesのメッセージカード情報を更新する
    if (change_flag === true) {
        // 数量をセット
        let quantity = 1;

        // パラメータをセット
        let product_params = {
            'id': tool_variant_id,
            'quantity': quantity
        }

        // カート情報更新時に使用するパラメータセット
        let add_params = {
            'attributes':{
                'tool': toolSelectValue,
                'vendor_attribute': vendorAttributeValue,
                'omoi_tool_q1': omoiToolQ1Value,
                'omoi_tool_q2': omoiToolQ2Value,
                'omoi_tool_q3': omoiToolQ3Value,
                'omoi_tool_q4': omoiToolQ4Value,
                'tool_variant_id': tool_variant_id,
                'vendor_attribute_url': tsukurite,
                'scene': sceneSelectValue,
            }
        }
        if (toolSelectValue === '本') {
            add_params['attributes']['delivery_type'] = deliveryTypeValue;
            add_params['attributes']['author_name'] = authorNameValue;
            add_params['attributes']['omoi_tool_q1'] = omoiToolQ1Value;
            add_params['attributes']['omoi_tool_q2'] = omoiToolQ2Value;
            add_params['attributes']['recipient_name'] = null;
        } else if (toolSelectValue === 'メッセージカード') {
            add_params['attributes']['delivery_type'] = null;
            add_params['attributes']['author_name'] = null;
            add_params['attributes']['omoi_tool_q1'] = null;
            add_params['attributes']['omoi_tool_q2'] = null;
            add_params['attributes']['recipient_name'] = recipientNameValue;
        } else {
            add_params['attributes']['delivery_type'] = null;
            add_params['attributes']['author_name'] = null;
            add_params['attributes']['omoi_tool_q1'] = null;
            add_params['attributes']['omoi_tool_q2'] = null;
            add_params['attributes']['recipient_name'] = null;
        }

        // カートイン
        fetch("/cart/add.js", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(product_params)
        })
            .then(() => {
                deleteOptionProduct(current_selected_tool_variant_id, add_params, true);
            })
            .catch(error => {
                console.log(error);
            })
        ;
    } else {
        updateAttributesWithMessageData(toolSelectValue, deliveryTypeValue, vendorAttributeValue, authorNameValue, recipientNameValue, omoiToolQ1Value, omoiToolQ2Value, omoiToolQ3Value, omoiToolQ4Value, tool_variant_id, tsukurite, sceneSelectValue, true);
    }
}

/**
 * オプション商品をカートから削除する
 * @param variant_id
 * @param add_params 追加パラメータ
 * @param redirect （true=最終的にリダイレクトする, false=しない）
 */
function deleteOptionProduct(variant_id, add_params = {}, redirect= true) {
    // 誤操作防止のためinputタグ、aタグを非活性化
    document.querySelectorAll("a").forEach(e => e.setAttribute('href', 'javascript:void(0)'));
    document.querySelectorAll("input").forEach(e => e.disabled = true);

    // パラメータをセット
    let params = {
        'updates':{
            [variant_id]: 0
        }
    }
    if (Object.keys(add_params).length >= 1) {
        // 追加パラメータがある場合
        params = {...params, ...add_params};
    } else {
        // attributesを空更新する
        params['attributes'] = {
            'vendor': null,
            'tool': null,
            'delivery_type': null,
            'vendor_attribute': null,
            'author_name': null,
            'recipient_name': null,
            'omoi_tool_q1': null,
            'omoi_tool_q2': null,
            'omoi_tool_q3': null,
            'omoi_tool_q4': null,
            'tool_variant_id': null,
            'vendor_attribute_url': null,
            'scene': null,
        };
    }

    // カート情報更新
    updateCartApi(params, redirect);
}

/**
 * 元々選択していたツールと異なるツールを選択して保存した場合、現在カートに入っているツールを削除し、新たに選択したツールをカートインしなおす
 * @param variant_id
 * @param option
 * @return void
 */
function changeToolForEdit (variant_id, option='') {
    // 誤操作防止のためinputタグ、aタグを非活性化
    document.querySelectorAll("a").forEach(e => e.setAttribute('href', 'javascript:void(0)'));
    document.querySelectorAll("input").forEach(e => e.disabled = true);

    // パラメータをセット
    let params = {
        'updates':{
            [variant_id]: 0
        },
        'attributes':{
            'tool': null,
            'delivery_type': null,
            'vendor_attribute': null,
            'author_name': null,
            'omoi_tool_q1': null,
            'omoi_tool_q2': null,
            'omoi_tool_q3': null,
            'omoi_tool_q4': null,
            'tool_variant_id': null,
        }
    }

    // カート情報更新
    updateCartApi(params, true);
}

/**
 * Cart Attributesのメッセージカード情報を更新する
 * @param tool
 * @param deliveryType
 * @param vendorAttribute
 * @param authorName
 * @param omoiToolQ1
 * @param omoiToolQ2
 * @param omoiToolQ3
 * @param omoiToolQ4
 * @param variant_id
 * @param variant_id
 * @param tsukurite
 * @return void
 */
function updateAttributesWithMessageData(tool, deliveryType, vendorAttribute, authorName, recipientName, omoiToolQ1, omoiToolQ2, omoiToolQ3, omoiToolQ4, variant_id, tsukurite, sceneSelectValue, redirect) {
    // パラメータをセット
    let params = {
        'attributes':{
            'tool': tool,
            'vendor_attribute': vendorAttribute,
            'omoi_tool_q1': omoiToolQ1,
            'omoi_tool_q2': omoiToolQ2,
            'omoi_tool_q3': omoiToolQ3,
            'omoi_tool_q4': omoiToolQ4,
            'tool_variant_id': variant_id,
            'vendor_attribute_url': tsukurite,
            'scene': sceneSelectValue,
        }
    }
    if (tool === '本') {
        params['attributes']['delivery_type'] = deliveryType;
        params['attributes']['author_name'] = authorName;
        params['attributes']['omoi_tool_q1'] = omoiToolQ1;
        params['attributes']['omoi_tool_q2'] = omoiToolQ2;
        params['attributes']['recipient_name'] = null;
    } else if (tool === 'メッセージカード') {
        params['attributes']['delivery_type'] = null;
        params['attributes']['author_name'] = null;
        params['attributes']['omoi_tool_q1'] = null;
        params['attributes']['omoi_tool_q2'] = null;
        params['attributes']['recipient_name'] = recipientName;
    } else {
        params['attributes']['delivery_type'] = null;
        params['attributes']['author_name'] = null;
        params['attributes']['omoi_tool_q1'] = null;
        params['attributes']['omoi_tool_q2'] = null;
        params['attributes']['recipient_name'] = null;
    }

    // カート情報更新
    updateCartApi(params, redirect);
}

/**
 * Cart API update.js
 * カート情報更新
 * @param params
 * @param redirect
 */
function updateCartApi(params, redirect = false) {
    fetch("/cart/update.js", {
        method: "POST",
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(() => {
            if (redirect === true) {
                window.location.href = '/cart';
            }
        })
        .catch(error => {
            console.log(error);
        })
    ;
}

/**
 * メッセージカードの入力欄をチェックする
 * @param tool （book or messageCard or noTool）
 * @param authorName （element）
 * @param omoiToolQ1 （element）
 * @param omoiToolQ2 （element）
 * @param omoiToolQ3 （element）
 * @param omoiToolQ4 （element）
 * @return boolean （true=エラーあり, false=エラーなし）
 */
function checkMessageInput(tool, authorName, recipientName, omoiToolQ1, omoiToolQ2, omoiToolQ3, omoiToolQ4) {
    let error_flg = false;

   // 本のみチェック
    if (tool == 'book') {
        // 本の著者名
        if (checkLengthText(authorName) === true || checkStrings(authorName) === true) {
            error_flg = true;
        }
        // Q1
        if (checkLengthText(omoiToolQ1) === true || checkStrings(omoiToolQ1) === true) {
            error_flg = true;
        }
        // Q2
        if (checkLengthText(omoiToolQ2) === true || checkStrings(omoiToolQ2) === true) {
            error_flg = true;
        }
    }

    // メッセージカードのみチェック
    if (tool == 'messageCard') {
        // 贈られる方氏名
        if (checkLengthText(recipientName) === true || checkStrings(recipientName) === true) {
            error_flg = true;
        }
    }

    // Q3
    if (checkLengthText(omoiToolQ3) === true || checkStrings(omoiToolQ3) === true) {
        error_flg = true;
    }
    // Q4
    if (checkLengthText(omoiToolQ4) === true || checkStrings(omoiToolQ4) === true) {
        error_flg = true;
    }

    return error_flg;
}

/**
 * テキストの文字数をチェックする
 * @param ele （element）
 * @return boolean （true=エラーあり, false=エラーなし）
 */
function checkLengthText(ele) {
    let error_flg = false;
    let value = ele.value;

    //現在の文字数を取得
    let len = value.length;

    // 最大文字数の取得
    let max_length = '';
    if (ele.id === 'author_name') {
        max_length = ele.getAttribute('maxlength');
    } else if (ele.id === 'recipient_name') {
        max_length = ele.getAttribute('maxlength');
    } else if (ele.id === 'omoi_tool_q1') {
        max_length = ele.getAttribute('maxlength');
    } else if (ele.id === 'omoi_tool_q2') {
        max_length = ele.getAttribute('maxlength');
    } else if (ele.id === 'omoi_tool_q3') {
        max_length = ele.getAttribute('maxlength');
    } else if (ele.id === 'omoi_tool_q4') {
        max_length = ele.getAttribute('maxlength');
    }

    // 空であれば
    if (len == 0) {
        error_flg = true;
        if (ele.id === 'author_name') {
            document.getElementById('error_author_name').textContent = '必須入力です';
            document.getElementById('error_author_name').style.display = 'block';
        } else if (ele.id === 'recipient_name') {
            document.getElementById('error_recipient_name').textContent = '必須入力です';
            document.getElementById('error_recipient_name').style.display = 'block';
        } else if (ele.id === 'omoi_tool_q1') {
            document.getElementById('error_q1').textContent = '必須入力です';
            document.getElementById('error_q1').style.display = 'block';
        } else if (ele.id === 'omoi_tool_q2') {
            document.getElementById('error_q2').textContent = '必須入力です';
            document.getElementById('error_q2').style.display = 'block';
        } else if (ele.id === 'omoi_tool_q3') {
            document.getElementById('error_q3').textContent = '必須入力です';
            document.getElementById('error_q3').style.display = 'block';
        } else if (ele.id === 'omoi_tool_q4') {
            document.getElementById('error_q4').textContent = '必須入力です';
            document.getElementById('error_q4').style.display = 'block';
        }
    } else {
        // もし最大文字数を超えていたら
        if (max_length < len) {
            error_flg = true;
            if (ele.id === 'author_name') {
                document.getElementById('error_author_name').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_author_name').style.display = 'block';
            } else if (ele.id === 'recipient_name') {
                document.getElementById('error_recipient_name').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_recipient_name').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q1') {
                document.getElementById('error_q1').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_q1').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q2') {
                document.getElementById('error_q2').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_q2').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q3') {
                document.getElementById('error_q3').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_q3').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q4') {
                document.getElementById('error_q4').textContent = '※' + max_length +'文字以内で入力してください';
                document.getElementById('error_q4').style.display = 'block';
            }

            // 超えていなければ
        } else {
            if (ele.id === 'author_name') {
                document.getElementById('error_author_name').textContent = '';
                document.getElementById('error_author_name').style.display = 'none';
            } else if (ele.id === 'recipient_name') {
                document.getElementById('error_recipient_name').textContent = '';
                document.getElementById('error_recipient_name').style.display = 'none';
            } else if (ele.id === 'omoi_tool_q1') {
                document.getElementById('error_q1').textContent = '';
                document.getElementById('error_q1').style.display = 'none';
            } else if (ele.id === 'omoi_tool_q2') {
                document.getElementById('error_q2').textContent = '';
                document.getElementById('error_q2').style.display = 'none';
            } else if (ele.id === 'omoi_tool_q3') {
                document.getElementById('error_q3').textContent = '';
                document.getElementById('error_q3').style.display = 'none';
            } else if (ele.id === 'omoi_tool_q4') {
                document.getElementById('error_q4').textContent = '';
                document.getElementById('error_q4').style.display = 'none';
            }
        }
    }

    return error_flg;
}

/**
 * 入力できない文字種が含まれていないかチェックする
 * @param ele （element）
 * @return boolean （true=エラーあり, false=エラーなし）
 */
function checkStrings(ele) {
    let error_flg = false;
    let char = ele.value;

    for (let i=0; i<char.length; i++) {
        if (
            !char.charAt(i).match(/[A-ZＡ-Ｚa-zａ-ｚ0-9０-９]/) //半角英数字・全角英数字
            && !char.charAt(i).match(/[!！\\?？()（）^＾★☆♪、。「」&＆／/@＠]/) //記号
            && !char.charAt(i).match(/[\x20\u3000]/) //スペース
            && !char.charAt(i).match(/[\n|\r\n|\r]/) //改行コード
            && !char.charAt(i).match(/[\u30a0-\u30ff\u3040-\u309f]/) //ひらがな・全角カタカナ
            && !char.charAt(i).match(/[\u4E00-\u9FFF\u3005]/) //漢字
        ) {
            error_flg = true;
            if (ele.id === 'author_name') {
                document.getElementById('error_author_name').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_author_name').style.display = 'block';
            } else if (ele.id === 'recipient_name') {
                document.getElementById('error_recipient_name').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_recipient_name').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q1') {
                document.getElementById('error_q1').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_q1').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q2') {
                document.getElementById('error_q2').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_q2').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q3') {
                document.getElementById('error_q3').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_q3').style.display = 'block';
            } else if (ele.id === 'omoi_tool_q4') {
                document.getElementById('error_q4').textContent = '※入力できない文字種が含まれています';
                document.getElementById('error_q4').style.display = 'block';
            }
            break;
        }
    }

    if (error_flg !== true) {
        if (ele.id === 'author_name') {
            document.getElementById('error_author_name').textContent = '';
            document.getElementById('error_author_name').style.display = 'none';
        } else if (ele.id === 'recipient_name') {
            document.getElementById('error_recipient_name').textContent = '';
            document.getElementById('error_recipient_name').style.display = 'none';
        } else if (ele.id === 'omoi_tool_q1') {
            document.getElementById('error_q1').textContent = '';
            document.getElementById('error_q1').style.display = 'none';
        } else if (ele.id === 'omoi_tool_q2') {
            document.getElementById('error_q2').textContent = '';
            document.getElementById('error_q2').style.display = 'none';
        } else if (ele.id === 'omoi_tool_q3') {
            document.getElementById('error_q3').textContent = '';
            document.getElementById('error_q3').style.display = 'none';
        } else if (ele.id === 'omoi_tool_q4') {
            document.getElementById('error_q4').textContent = '';
            document.getElementById('error_q4').style.display = 'none';
        }
    }

    return error_flg;
}

/**
 * メッセージカードプレビュー表示
 * @return void
 */
function clickMessagePreview() {
    // フォームの要素
    let toolSelectEle = document.getElementById('toolSelect');
    let sceneSelectEle = document.getElementById('sceneSelect');
    let authorNameEle = document.getElementById('author_name');
    let recipientNameEle = document.getElementById('recipient_name');
    let omoiToolQ1Ele = document.getElementById('omoi_tool_q1');
    let omoiToolQ2Ele = document.getElementById('omoi_tool_q2');
    let omoiToolQ3Ele = document.getElementById('omoi_tool_q3');
    let omoiToolQ4Ele = document.getElementById('omoi_tool_q4');

    let toolSelect = toolSelectEle.value;
    let sceneSelect = sceneSelectEle.value;
    let authorName = authorNameEle.value;
    let recipientName = recipientNameEle ? recipientNameEle.value : '';
    let omoiToolQ1 = omoiToolQ1Ele.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ2 = omoiToolQ2Ele.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ3 = omoiToolQ3Ele.value.replace(/(\r\n|\n|\r)/gm, "");
    let omoiToolQ4 = omoiToolQ4Ele.value.replace(/(\r\n|\n|\r)/gm, "");

    let authorNamePreview = document.querySelectorAll('.author-name');
    let recipientNamePreview = document.querySelectorAll('.recipient-name');
    let omoiToolQ1Preview = document.querySelectorAll('.omoi-tool-q1');
    let omoiToolQ2Preview = document.querySelectorAll('.omoi-tool-q2');
    let omoiToolQ3Preview = document.querySelectorAll('.omoi-tool-q3');
    let omoiToolQ4Preview = document.querySelectorAll('.omoi-tool-q4');

    // 入力エラーがある場合はプレビューを表示させない
    if (checkMessageInput(toolSelect, authorNameEle, recipientNameEle, omoiToolQ1Ele, omoiToolQ2Ele, omoiToolQ3Ele, omoiToolQ4Ele) === true) {
        return;
    }

    const modal = document.getElementById('modal-01');
    const modalOverlay = document.querySelector('.modal-overlay');
    const closeModalBtns = document.querySelectorAll('.modal-close, .modal-overlay');

    modal.classList.add('show');

    closeModalBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            modal.classList.remove('show');
        });
    });

    let vendorSelect = document.getElementById("vendor-select");
    let vendorName = vendorSelect.options[vendorSelect.selectedIndex].text;
    vendorName = vendorName.replace(/ /g, "_");

    // 「本」の処理
    for (let no = 5; no <= 30; no++) {
        let imageElement = document.getElementById(`preview-image-${no}`);
        if (imageElement) { // Check if the element exists
            imageElement.src = `${window.baseUrl}/images/preview/book_${sceneSelect}/${vendorName}/book_${sceneSelect}_${vendorName}_${no}.jpg`;

        } else {
            console.log(`preview-image-${no} is not found`);
        }
    }

    // 「メッセージカード」の処理
    for (let no = 1; no <= 2; no++) {
        let imageElement = document.getElementById(`preview-card-image-${no}`);
        if (imageElement) { // Check if the element exists
            imageElement.src = `${window.baseUrl}/images/preview/card_${sceneSelect}/card-${no}.jpg`;
        } else {
            console.log(`preview-card-image-${no} is not found`);
        }
    }
    
    // メッセージカードのテキストをシーンに応じて更新
    updateMessageCardTexts(sceneSelect);

    authorNamePreview.forEach(function(el) {
        let modifiedAuthorName = authorName.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedAuthorName += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedAuthorName;
    });
    
    recipientNamePreview.forEach(function(el) {
        let modifiedRecipientName = recipientName.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedRecipientName += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedRecipientName;
    });

    omoiToolQ1Preview.forEach(function(el) {
        let modifiedText1 = omoiToolQ1.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedText1 += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedText1;
    });

    omoiToolQ2Preview.forEach(function(el) {
        let modifiedText2 = omoiToolQ2.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedText2 += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedText2;
    });
  
    omoiToolQ3Preview.forEach(function(el) {
        let modifiedText3 = omoiToolQ3.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedText3 += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedText3;
    });
  
    omoiToolQ4Preview.forEach(function(el) {
        let modifiedText4 = omoiToolQ4.replace(/\n/g, '<span style="visibility:hidden;">a</span><br>');
        modifiedText4 += '<span style="visibility:hidden;">a</span>';
        el.innerHTML = modifiedText4;
    });
}

/**
 * 文字数カウンター
 * @param column
 * @return void
 */
function viewStrLen(column){
    let ele = document.getElementById(column);
    let value = document.getElementById(column).value;

    // 現在の文字数を取得
    let len = value.length;
    // for (let i = 0; i < value.length; i++) {
    //     (value[i].match(/[ -~]/)) ? len += 1 : len += 2; //マルチバイトの場合は2文字でカウント
    // }

    // 最大文字数の取得
    let max_length = ''
    if (column === 'author_name') {
        max_length = ele.getAttribute('maxlength');
    } else if (column === 'recipient_name') {
        max_length = ele.getAttribute('maxlength');
    } else if (column === 'omoi_tool_q1') {
        max_length = ele.getAttribute('maxlength');
    } else if (column === 'omoi_tool_q2') {
        max_length = ele.getAttribute('maxlength');
    } else if (column === 'omoi_tool_q3') {
        max_length = ele.getAttribute('maxlength');
    } else if (column === 'omoi_tool_q4') {
        max_length = ele.getAttribute('maxlength');
    }

    // 文字数カウンターを更新
    document.getElementById(column + "_length").innerText = len + " / " + max_length + "文字";
}

/**
 * ツールによって文字数制限を変える
 * @param tool
 * @return void
 */
function addMaxLength(tool) {
    // 本の場合のmaxLengthを追加
    if (tool === 'book') {
        document.getElementById('author_name').setAttribute('maxlength', Q_AUTHORNAME_MAX_LENGTH);
        document.getElementById('omoi_tool_q1').setAttribute('maxlength', Q_BOOK_MAX_LENGTH);
        document.getElementById('omoi_tool_q2').setAttribute('maxlength', Q_BOOK_MAX_LENGTH);
        document.getElementById('omoi_tool_q3').setAttribute('maxlength', Q_BOOK_MAX_LENGTH);
        document.getElementById('omoi_tool_q4').setAttribute('maxlength', Q_BOOK_MAX_LENGTH);

        // メッセージカードの場合のmaxLengthを追加
    } else if (tool === 'messageCard') {
        document.getElementById('recipient_name').setAttribute('maxlength', Q_AUTHORNAME_MAX_LENGTH);
        document.getElementById('omoi_tool_q1').setAttribute('maxlength', Q_MESSAGECARD_MAX_LENGTH);
        document.getElementById('omoi_tool_q2').setAttribute('maxlength', Q_MESSAGECARD_MAX_LENGTH);
        document.getElementById('omoi_tool_q3').setAttribute('maxlength', Q_MESSAGECARD_MAX_LENGTH);
        document.getElementById('omoi_tool_q4').setAttribute('maxlength', Q_MESSAGECARD_MAX_LENGTH);
    }
}

/**
 * 想いを届けるツールフィールドの開閉
 * @param acdContent
 * @param btn
 * @param addClass
 * @return void
 */
function dropdown(acdContent, btn, addClass) {
    if (addClass) {
        acdContent.classList.add('dropdown-expanded');
        btn.classList.add('item-added');
    } else {
        acdContent.classList.remove('dropdown-expanded');
        btn.classList.remove('item-added');
    }
}


/**
 * ページ読み込み後に実行する処理
 */
document.addEventListener('DOMContentLoaded', function() {
    const toolSelect = document.getElementById('toolSelect');
    const sceneSelect = document.getElementById('sceneSelect');
    const acdContent = document.querySelector('.js-dropdown-content');
    const authorLabel = document.getElementById('authorLabel');
    const deliveryTypeSelect = document.getElementById('deliveryTypeSelect');
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const previewBook = document.querySelector('.preview-book');
    const previewMessageCard = document.querySelector('.preview-messagecard');

    // 質問の<label>タグを取得
    const q1Label = document.querySelector('label[for="omoi_tool_q1"]');
    const q2Label = document.querySelector('label[for="omoi_tool_q2"]');
    const q3Label = document.querySelector('label[for="omoi_tool_q3"]');
    const q4Label = document.querySelector('label[for="omoi_tool_q4"]');

    // 質問の<p>タグを取得
    const q1 = document.querySelector('label[for="omoi_tool_q1"] p');
    const q2 = document.querySelector('label[for="omoi_tool_q2"] p');
    const q3 = document.querySelector('label[for="omoi_tool_q3"] p');
    const q4 = document.querySelector('label[for="omoi_tool_q4"] p');

    checkoutButton.disabled = true;
    checkoutButton.classList.add('disabled');

if (localStorage.getItem('tool') == 'none') {
        toolSelect.value = 'noTool';
        localStorage.removeItem('tool');
    }

    // すでにツールを選択している場合は展開状態にする
    if (toolSelect.value !== '') {
        const tool = toolSelect.value;

        if (tool === 'book' || tool === 'messageCard') {
            // 質問文を切り替える処理
            if (sceneSelect.value === 'farewell' || sceneSelect.value === 'other') {
                // 送別・その他（誕生日・記念日）の質問文
                q1.textContent = 'お相手の方の第一印象は、どのような印象でしたか？';
                q2.textContent = 'お相手の素敵なところは、どのようなところですか？';
                q3.textContent = 'お相手の方へのメッセージを記載してください';
                q4.textContent = 'なぜ、このつくり手のストーリーや商品を贈ろうと思いましたか？';
            } else if (sceneSelect.value === 'wedding_father') {
                // 父親向けの質問文
                q1.textContent = '父親の尊敬しているところは、どこですか？';
                q2.textContent = '一番印象に残っている父親との思い出は、どのようなものですか？';
                q3.textContent = '父親への感謝の言葉を記載してください';
                q4.textContent = 'なぜ、このストーリーを持つギフトを贈ろうと思いましたか？';
            } else if (sceneSelect.value === 'wedding_mother') {
                // 母親向けの質問文
                q1.textContent = '母親の尊敬しているところは、どこですか？';
                q2.textContent = '一番印象に残っている母親との思い出は、どのようなものですか？';
                q3.textContent = '母親への感謝の言葉を記載してください';
                q4.textContent = 'なぜ、このストーリーを持つギフトを贈ろうと思いましたか？';
            } else {
                // 上記以外はデフォルトを表示
                q1.textContent = 'お相手の方の第一印象は、どのような印象でしたか？';
                q2.textContent = 'お相手の素敵なところは、どのようなところですか？';
                q3.textContent = 'お相手の方へのメッセージを記載してください';
                q4.textContent = 'なぜ、このつくり手のストーリーや商品を贈ろうと思いましたか？';
            }

            dropdown(sceneSelect, toolSelect, true);
            dropdown(acdContent, toolSelect, true);
            checkoutButton.disabled = false;
            checkoutButton.classList.remove('disabled');
            addMaxLength(tool);

            // 本の場合のみ著者名/送り主フィールドを表示させる
            if (tool === 'book') {
                authorLabel.style.display = 'block';
                deliveryTypeSelect.style.display = 'block';
                q1Label.style.display = 'block';
                q2Label.style.display = 'block';

                //プレレビュー（book）を表示
                previewBook.style.display = 'block';
                //プレレビュー（messagecard）を非表示
                previewMessageCard.style.display = 'none';
            } else {
                authorLabel.style.display = 'none';
                deliveryTypeSelect.style.display = 'none';
                q1Label.style.display = 'none';
                q2Label.style.display = 'none';

                //プレレビュー（book）を非表示
                previewBook.style.display = 'none';
                //プレレビュー（messagecard）を表示
                previewMessageCard.style.display = 'block';
            }
        } else if (tool === 'noTool') {
            dropdown(sceneSelect, toolSelect, false);
            dropdown(acdContent, toolSelect, false);
            checkoutButton.disabled = false;
            checkoutButton.classList.remove('disabled');
            authorLabel.style.display = 'none';
            deliveryTypeSelect.style.display = 'none';
            // ツール無し選択時の購入ボタン処理を設定
            setupNoToolCheckout();
        }
    }

    // ツールの選択が切り替わったら
    toolSelect.addEventListener('change', function() {
        const tool = this.value;
        if (tool === 'book' || tool === 'messageCard') {
            checkoutButton.disabled = true;
            checkoutButton.classList.add('disabled');
            addMaxLength(tool);

          ['author_name','omoi_tool_q1','omoi_tool_q2','omoi_tool_q3','omoi_tool_q4']
                .forEach(id => {
                    const el = document.getElementById(id);
                    if (el) viewStrLen(id);
                });

            // 本の場合のみ著者名/送り主フィールドを表示させる
            if (tool === 'book') {
                authorLabel.style.display = 'block';
                deliveryTypeSelect.style.display = 'block';
                q1Label.style.display = 'block';
                q2Label.style.display = 'block';

                //プレレビュー（book）を表示
                previewBook.style.display = 'block';
                //プレレビュー（messagecard）を非表示
                previewMessageCard.style.display = 'none';
            } else {
                authorLabel.style.display = 'none';
                deliveryTypeSelect.style.display = 'none';
                q1Label.style.display = 'none';
                q2Label.style.display = 'none';

                //プレレビュー（book）を非表示
                previewBook.style.display = 'none';
                //プレレビュー（messagecard）を表示
                previewMessageCard.style.display = 'block';
            }

            dropdown(sceneSelect, this, true);

        } else if (tool === 'noTool') {
            dropdown(sceneSelect, this, false);
            dropdown(acdContent, this, false);
            checkoutButton.disabled = false;
            checkoutButton.classList.remove('disabled');
            authorLabel.style.display = 'none';
            deliveryTypeSelect.style.display = 'none';
            // ツール無し選択時の購入ボタン処理を設定
            setupNoToolCheckout();
        }
    });

    /**
     * 質問文を更新する関数
     * @param {string} scene - 選択されたシーン
     * @param {HTMLElement} q1 - Q1の<p>要素
     * @param {HTMLElement} q2 - Q2の<p>要素
     * @param {HTMLElement} q3 - Q3の<p>要素
     * @param {HTMLElement} q4 - Q4の<p>要素
     */
    function updateQuestions(scene, q1, q2, q3, q4) {
        if (scene === 'farewell' || scene === 'other') {
            // 送別の質問文、その他（誕生日・記念日）の質問文
            q1.textContent = 'お相手の方の第一印象は、どのような印象でしたか？';
            q2.textContent = 'お相手の素敵なところは、どのようなところですか？';
            q3.textContent = 'お相手の方へのメッセージを記載してください';
            q4.textContent = 'なぜ、このつくり手のストーリーや商品を贈ろうと思いましたか？';
        } else if (scene === 'wedding_father') {
            // 父親向けの質問文
            q1.textContent = '父親の尊敬しているところは、どこですか？';
            q2.textContent = '一番印象に残っている父親との思い出は、どのようなものですか？';
            q3.textContent = '父親への感謝の言葉を記載してください';
            q4.textContent = 'なぜ、このストーリーを持つギフトを贈ろうと思いましたか？';
        } else if (scene === 'wedding_mother') {
            // 母親向けの質問文
            q1.textContent = '母親の尊敬しているところは、どこですか？';
            q2.textContent = '一番印象に残っている母親との思い出は、どのようなものですか？';
            q3.textContent = '母親への感謝の言葉を記載してください';
            q4.textContent = 'なぜ、このストーリーを持つギフトを贈ろうと思いましたか？';
        } else {
            // デフォルト
            q1.textContent = 'お相手の方の第一印象は、どのような印象でしたか？';
            q2.textContent = 'お相手の素敵なところは、どのようなところですか？';
            q3.textContent = 'お相手の方へのメッセージを記載してください';
            q4.textContent = 'なぜ、このつくり手のストーリーや商品を贈ろうと思いましたか？';
        }
    }

    // 前回の選択値を保持するための変数
    let previousScene = sceneSelect.value;

    sceneSelect.addEventListener('change', function() {
        const newScene = this.value;

        // 初回変更時は確認ダイアログを表示しない
        if (!previousScene) {
            updateQuestions(newScene, q1, q2, q3, q4);
            previousScene = newScene; // 前回の値を更新
            dropdown(acdContent, this, true);
            return;
        }

        const confirmation = confirm("シーンの切り替えは質問内容も変わります。切り替えてよろしいですか？");

        if (confirmation) {
            // ユーザーがOKを選択した場合
            updateQuestions(newScene, q1, q2, q3, q4);
            previousScene = newScene; // 前回の値を更新
            dropdown(acdContent, this, true);
            checkoutButton.disabled = true;
            checkoutButton.classList.add('disabled');
        } else {
            // ユーザーがキャンセルを選択した場合
            this.value = previousScene; // 前回の値に戻す
        }
    });

    // // All In One Giftの「相手が選べるギフトサービスを利用する」がクリックされたら
    // const giftbutton = document.getElementById('radio-:r7:');
    // giftbutton.addEventListener('click', function() {
    //     const giftCheckoutButton = document.querySelector('.chakra-button.css-obu0c2');
    //     giftCheckoutButton.disabled = true;

    //     const tool = toolSelect.value;
    //     if (tool === 'book' || tool === 'messageCard') {
    //         giftCheckoutButton.disabled = false;
    //     } else if (tool === 'noTool' || tool === '') {
    //         dropdown(acdContent, toolSelect, false);
    //         checkoutButton.disabled = false;
    //         giftCheckoutButton.disabled = false;
    //         authorLabel.style.display = 'none';
    //     }


    //     // ボタンが存在する場合、disabled属性を設定して非活性化
    //     if (button) {
    //         button.disabled = true;
    //     }
    // });
});

/**
 * ツール無し選択時の購入ボタンクリック処理を設定
 */
function setupNoToolCheckout() {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const form = document.querySelector('form.cart-page');
    
    if (!checkoutButton || !form) return;
    
    // 既存のイベントリスナーを削除（重複防止）
    const newCheckoutButton = checkoutButton.cloneNode(true);
    checkoutButton.parentNode.replaceChild(newCheckoutButton, checkoutButton);
    
    // 新しいイベントリスナーを追加
    newCheckoutButton.addEventListener('click', function(e) {
        const toolSelect = document.getElementById('toolSelect');
        
        // ツール無しが選択されている場合
        if (toolSelect && toolSelect.value === 'noTool') {
            e.preventDefault();
            saveNoToolAttributesAndCheckout();
        }
    });
}

/**
 * メッセージカードのテキストをシーンに応じて更新
 * @param {string} scene - 選択されたシーン
 */
function updateMessageCardTexts(scene) {
    const fixedMessageElement = document.getElementById('fixed-message-card');
    const messageTitleElement = document.getElementById('message-title');
    const storyTitleElement = document.getElementById('story-title');
    
    if (!fixedMessageElement || !messageTitleElement || !storyTitleElement) {
        return;
    }
    
    // 1ページ目の固定メッセージ
    if (scene === 'wedding_father' || scene === 'wedding_mother') {
        fixedMessageElement.innerHTML = `
            言葉では言い表せないほどの、<br>
            感謝の気持ちをストーリーに託して。<br>
            今日この日まで大切に育ててくれてありがとう。<br>
            どうかこの贈り物に込められたストーリーが、<br>
            わたしの気持ちを届けてくれますように。
        `;
    } else {
        fixedMessageElement.innerHTML = `
            あなたのことを考えて、<br>
            たくさんのありがとうや<br>
            リスペクトの気持ちを込めて。<br>
            贈り物とひとつのストーリーを、届けます。<br>
            <br>
        `;
    }
    
    // 2ページ目のタイトル
    if (scene === 'wedding_father') {
        messageTitleElement.textContent = '父へのメッセージ';
    } else if (scene === 'wedding_mother') {
        messageTitleElement.textContent = '母へのメッセージ';
    } else {
        messageTitleElement.textContent = 'あなたへのメッセージ';
    }
    
    storyTitleElement.textContent = 'このストーリー/ギフトを選んだ理由';
}

/**
 * ツール無し選択時にカートのattributesを保存してからチェックアウト
 */
function saveNoToolAttributesAndCheckout() {
    const vendorSelectNoTool = document.getElementById('vendor-select-notool');
    const selectedOption = vendorSelectNoTool.options[vendorSelectNoTool.selectedIndex];
    const vendorAttribute = selectedOption.value;
    const tsukurite = selectedOption.getAttribute('data-tsukurite');
    
    // カートのattributesを更新
    const params = {
        'attributes': {
            'tool': 'ツール無し',
            'vendor_attribute': vendorAttribute,
            'vendor_attribute_url': tsukurite
        }
    };
    
    // カートを更新
    fetch("/cart/update.js", {
        method: "POST",
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(params)
    })
    .then(response => response.json())
    .then(data => {
        // カート更新成功後、チェックアウトページへ遷移
        window.location.href = '/checkout';
    })
    .catch(error => {
        console.error('Error updating cart:', error);
        alert('エラーが発生しました。もう一度お試しください。');
    });
}